import React, { Component } from 'react'
import { Button } from '../../../components'
import { StyleModal } from './style'
import { MODAL_STATUS } from '../../../helpers'
  export class ModalStatus extends Component {

  checkCode = () =>{
    const {
      onClick,
    } = this.props
    // if(code === '401' || !text)
    // {
    //   window.location.reload()
    // }
    // else
    // {
      onClick()
    // }
  }
  render () {
    const {
      action,
      text,
      status,
      onClick,
      language = 'EN',
      messageKey,
      colorTheme,
    } = this.props

    return (
      <StyleModal colorTheme={colorTheme}>
        <div className='div-Modal' />
        <div className='content-Modal'>
          { status?
            <React.Fragment>
              <div className='head-modal'>{action}</div>
              <div className='text-modal'>{text}</div>
              <Button
                name={MODAL_STATUS.OK[language]}
                onClick={onClick}
                className='modal-btn-confirm'
              />
            </React.Fragment>
            :
            <React.Fragment>
              <div className='head-modal-error'>
                {
                  messageKey === 'emailTokenNotFound' 
                  ? MODAL_STATUS.WARNING[language]
                  : action ? action: MODAL_STATUS.ERROR[language]
                }
              </div>
              <div className='text-modal-error'>
                  {
                    text ?
                      (React.isValidElement(text) ? text : (
                        typeof text === 'string' ? text : (
                          Array.isArray(text) ? text.map(t => t.message || JSON.stringify(t)).join(', ') : (text.message || JSON.stringify(text))
                        )
                      ))
                    :
                    MODAL_STATUS.TEXT_ERROR_1[language]
                  }
              </div>
              <Button
                // name={isCode || !text? MODAL_STATUS.REFRESH[language]: MODAL_STATUS.BACK[language]}
                name={
                  messageKey === 'emailTokenNotFound' 
                  ? MODAL_STATUS.BACK_TO_LOGIN[language]
                  : MODAL_STATUS.BACK[language]
                }
                onClick={this.checkCode}
                className='modal-btn-back'
                // classIcon='ic_btn'
              />
            </React.Fragment>
          }
        </div>
      </StyleModal>
    )
  }
}
